export default "__VITE_ASSET__fcb29560__"